module.exports = __webpack_public_path__ + "static/media/pengumuman.3a9f24d8.svg";